import React, { forwardRef } from 'react';
import EnhetTypeahead, { EnhetTypeaheadRef } from 'components/EnhetTypeahead';

import { PickedEnhet } from 'components/EnhetTypeahead/types';

import useToaster from 'utils/hooks/useToaster';

import Style from './index.module.css';

interface Props {
  onChange: (enhet: PickedEnhet) => void;
  enhetID: number;
  lopenummer: string;
  bruktEnhet: boolean;
  erPublisert?: boolean;
  initialEnhetIsNotAktiv?: boolean;
  nedlagtDato?: Date;
  oppstartsdato?: Date;
}

const QAEnhetSearch = forwardRef<EnhetTypeaheadRef, Props>((props, ref) => {
  const toaster = useToaster();
  return (
    <div className={Style.enhetSearchWrapper}>
      <div style={{ marginTop: '0.5rem' }}>
        <EnhetTypeahead
          ref={ref}
          size="sm"
          showFilters
          selectedLopenummer={props.lopenummer}
          initialEnhetIsNotAktiv={props.initialEnhetIsNotAktiv}
          onChange={props.onChange}
        />
      </div>
    </div>
  );
});

QAEnhetSearch.displayName = 'QAEnhetSearch';

export default QAEnhetSearch;
